export default "__VITE_ASSET__gXdssdp9__"